import {getLocale} from "../locale/AppLocale";

export const GetEntityAttribute = (entity, attribute, defaultVal = '') => {

    let langCode = getLocale();

    // if (['title'].indexOf(attribute) !== -1) {
        if (typeof entity[`${attribute}_${langCode.code}`] !== 'undefined' && entity[`${attribute}_${langCode.code}`] && entity[`${attribute}_${langCode.code}`].length) {
            return entity[`${attribute}_${langCode.code}`];
        } else if (typeof entity[`${attribute}_ar`] !== 'undefined') {
            return entity[`${attribute}_ar`];
        }
    // }
    if (typeof entity[attribute] === 'undefined') {
        return defaultVal;
    }
    return entity[attribute];

};